import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { supabase } from '../../utils/auth';

const BATCH_SIZE = 1000;

export const loadSectors = createAsyncThunk(
    'map/loadSectors',
    async (_, { rejectWithValue }) => {
        try {
            const allSectors = [];
            let from = 0;
            let hasMore = true;

            while (hasMore) {
                const { data, error } = await supabase
                    .from('sectors')
                    .select(`
                        id,
                        sector_id,
                        geometry,
                        district_id,
                        zone_type_id,
                        restriction_status_id,
                        buildings_count,
                        max_building_height,
                        has_trees,
                        max_tree_height,
                        has_powerlines,
                        max_powerline_height,
                        min_flight_altitude,
                        max_flight_altitude,
                        special_permission_required,
                        allowed_days,
                        allowed_time_start,
                        allowed_time_end,
                        temporary_restriction,
                        temporary_restriction_start,
                        temporary_restriction_end,
                        temporary_restriction_description,
                        created_at,
                        districts:district_id (
                            id,
                            name_ru,
                            name_kz,
                            name_en
                        ),
                        zone_types:zone_type_id (
                            id,
                            value,
                            name_ru,
                            name_kz,
                            name_en
                        ),
                        sector_statuses:restriction_status_id (
                            id,
                            value,
                            name_ru,
                            name_kz,
                            name_en,
                            color
                        )
                    `)
                    .range(from, from + BATCH_SIZE - 1)
                    .order('created_at', { ascending: true });

                if (error) throw error;

                if (data && data.length > 0) {
                    allSectors.push(...data);
                    from += BATCH_SIZE;
                    hasMore = data.length === BATCH_SIZE;
                } else {
                    hasMore = false;
                }
            }

            return allSectors;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const initialState = {
    mapType: 'satellite', // 'satellite', 'outdoor3d', 'streets2d'
    sectors: [],
    loading: false,
    error: null
};

const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setMapType: (state, action) => {
            state.mapType = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadSectors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadSectors.fulfilled, (state, action) => {
                state.loading = false;
                state.sectors = action.payload;
            })
            .addCase(loadSectors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setMapType } = mapSlice.actions;
export default mapSlice.reducer;

